import React from "react"

import withService from "utils/hoc/withService"
import { fetchData } from "utils/api/clients/election-tracker"
import { getServiceProps, getPageProps } from "utils/ssg"
import ElectionTracker from "components/pages/services/election-tracker"

const Page = props => <ElectionTracker {...props} />

export const getStaticProps = async ({ locale: language }) => {
  const data = await fetchData(language)
  const serviceProps = await getServiceProps("page--1fd94de8", language)

  return await getPageProps({
    language,
    namespaces: ["og_page--1fd94de8"],
    pageProps: { data, ...serviceProps },
    revalidate: 3600,
  })
}

export default withService(Page)
